import { clsx } from 'clsx';
import * as React from 'react';
import * as styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var InlineIconText = function InlineIconText(_ref) {
  var beforeIcon = _ref.beforeIcon,
    afterIcon = _ref.afterIcon,
    children = _ref.children,
    textClassName = _ref.textClassName;
  if (!beforeIcon && !afterIcon) {
    return /*#__PURE__*/_jsx("span", {
      className: textClassName,
      children: children
    });
  }
  return /*#__PURE__*/_jsxs("span", {
    className: styles['nowrap'],
    children: [beforeIcon, "\u2060", /*#__PURE__*/_jsx("span", {
      className: clsx(styles['wrap'], textClassName),
      children: children
    }), "\u2060", afterIcon]
  });
};